import { useMemo, useState } from "react";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import Button from "../../button/Button";
import { FlexContent, Title } from "../../layout";
import AttachmentsGalleryDetailView from "./AttachmentsGalleryDetailView";
import { CPAttachment } from "../../../api/models/unified";
import AttachmentsGalleryTableView from "./AttachmentsGalleryTableView";
import { isImage } from "../../../helpers/attachmentsHelepr";
import ImageViewer from "../ImageViewer";

interface AttachmentsGalleryProps {
  attachments: CPAttachment[];
  className?: string;
}

type AttachmentsGalleryMode = "detail" | "table";

const AttachmentsGallery = ({
  attachments,
  className,
}: AttachmentsGalleryProps) => {
  const { t } = useCustomTranslation();

  const [mode, setMode] = useState<AttachmentsGalleryMode>("detail");
  const [previewIndex, setPreviewIndex] = useState<number | null>(null);

  const images = useMemo(
    () => attachments.filter((x) => isImage(x)),
    [attachments],
  );

  return (
    <>
      <div className={`AttachmentsGallery${className ? ` ${className}` : ""}`}>
        <FlexContent>
          <Title className="mb-2.5 ml-5" title={t("attachments")} />
          <Button
            mode="link"
            onClick={() => setMode(mode === "detail" ? "table" : "detail")}
            label={
              mode === "detail" ? t("show_as_table") : t("show_as_previews")
            }
          />
        </FlexContent>
        {mode === "detail" ? (
          <AttachmentsGalleryDetailView
            attachments={attachments}
            handleOpenPreview={(attachment) =>
              setPreviewIndex(images.findIndex((x) => x.id === attachment.id))
            }
          />
        ) : (
          <AttachmentsGalleryTableView
            attachments={attachments}
            handleOpenPreview={(attachment) =>
              setPreviewIndex(images.findIndex((x) => x.id === attachment.id))
            }
          />
        )}
      </div>
      {previewIndex !== null && (
        <ImageViewer
          attachments={images}
          onClose={() => setPreviewIndex(null)}
          startIndex={previewIndex}
        />
      )}
    </>
  );
};

export default AttachmentsGallery;
